﻿// ==本JS是加载Lodop插件及CLodop服务的综合示例，可直接使用，建议看懂后融进自己页面程序==
import axios from 'axios'

/* eslint-disable */
let CreatedOKLodopObject, CLodopJsState;
const isNeedCLodop = needCLodop()
const version = '4.118'

// 登录系统后即可调用此方法
export function loadPrintJS() {
  try {
    if (isNeedCLodop) {
      let ipAddress = localStorage.getItem('printerIp')
      if (!ipAddress) { // 此处改成登录用户信息中的 打印机ip 地址
        ipAddress = 'localhost'
      }
      // CLodop的主JS初始化文件
      // 用双端口8000和18000(以防其中一个被占):==
      const src1 = 'http://' + ipAddress + ':8000/CLodopfuncs.js?priority=1'
      const src2 = 'http://' + ipAddress + ':18000/CLodopfuncs.js?priority=0'

      const head = document.head || document.getElementsByTagName('head')[0] || document.documentElement
      // 创建script标签
      let oscript = document.createElement('script')
      // 更新script的地址属性
      oscript.src = src1
      // 插入script到head标签的首元素
      head.insertBefore(oscript, head.firstChild)

      oscript = document.createElement('script')
      oscript.src = src2
      head.insertBefore(oscript, head.firstChild)
    }
  } catch (error) {
    alert('Error loading print js plug-in:' + error)
  }
}

// 打开模块时调用此方法
export function getLodop(installFn, updateFn) {
  let LODOP;
  try {
    // LODOP = window.getCLodop()
    // if (!LODOP && document.readyState !== 'complete') {
    //   setTimeout(getLodop, 500)
    //   return
    // }

    // if (!LODOP) {
    //   if (typeof installFn === 'function') installFn.call(this)
    //   //  快速打印弹出层安装插件
    //   // const print = document.getElementById('print-wrap')
    //   // print.style.display = 'block'
    //   return
    // }
    // if (LODOP.CVERSION < '4.1.0.3') {
    //   if (typeof updateFn === 'function') updateFn.call(this)
    //   return
    // }

    const ua = navigator.userAgent;
    const isIE = !!(ua.match(/MSIE/i)) || !!(ua.match(/Trident/i));
    if (isNeedCLodop) {
      try {
        window.LODOP = LODOP = getCLodop();
        if (!LODOP) {
          if (typeof installFn === 'function') installFn.call(this)
          return
        }
      } catch (err) { }
      if (!LODOP && (document.readyState !== 'complete' || (isIE && CLodopJsState == 'loading'))) {
        // alert('网页还没下载完毕，请稍等一下再操作.');
        setTimeout(getLodop, 500)
        return;
      }
      if (!LODOP) {
        // document.body.innerHTML = strCLodopInstall_1 + (CLodopIsLocal ? strCLodopInstall_2 : '') + strCLodopInstall_3 + document.body.innerHTML;
        return;
      } else {
        // if (CLODOP && CLODOP.CVERSION < '3.0.9.3') {
        //   document.body.innerHTML = strCLodopUpdate + document.body.innerHTML;
        // }
        // if (oEMBED && oEMBED.parentNode) { oEMBED.parentNode.removeChild(oEMBED); }
        // if (oOBJECT && oOBJECT.parentNode) { oOBJECT.parentNode.removeChild(oOBJECT); }
      }
    } else {
      // ==如果页面有Lodop就直接使用,否则新建:==
      if (oOBJECT || oEMBED) {
        if (isIE) { LODOP = oOBJECT; } else { LODOP = oEMBED; }
      } else if (!CreatedOKLodopObject) {
        LODOP = document.createElement('object');
        LODOP.setAttribute('width', 0);
        LODOP.setAttribute('height', 0);
        LODOP.setAttribute('style', 'position:absolute;left:0px;top:-100px;width:0px;height:0px;');
        if (isIE) { LODOP.setAttribute('classid', 'clsid:2105C259-1E0C-4534-8141-A753534CB4CA'); } else { LODOP.setAttribute('type', 'application/x-print-lodop'); }
        document.documentElement.appendChild(LODOP);
        CreatedOKLodopObject = LODOP;
      } else { LODOP = CreatedOKLodopObject; }
      // ==Lodop插件未安装时提示下载地址:==
      if ((!LODOP) || (!LODOP.VERSION)) {
        // if (ua.indexOf('Chrome') >= 0) { document.body.innerHTML = strHtmChrome + document.body.innerHTML; }
        // if (ua.indexOf('Firefox') >= 0) { document.body.innerHTML = strHtmFireFox + document.body.innerHTML; }
        // document.body.innerHTML = (is64IE ? strHtm64_Install : strHtmInstall) + document.body.innerHTML;
        return LODOP;
      }
    }

    // 版本号检查
    checkoutLodopVersion(updateFn)

    // ===如下空白位置适合调用统一功能(如注册语句、语言选择等):==
    LODOP.SET_LICENSES('深圳云路供应链科技有限公司', '9B32B3CAB83F42F52AAC6AC6F8801D7A374', '深圳雲路供應鏈科技有限公司', '8DB5C879EA93FE3CB1BDD5E34CB7CB151CC')
    LODOP.SET_LICENSES('THIRD LICENSE', '', 'Shenzhen Yunlu Supply Chain Technology Co., Ltd.', '37A8526098B15B8CD0F8000C23C7E041263')
    // =======================================================

    return LODOP
  } catch (err) {
    // 加载打印插件出错
    alert('Error loading print plug-in:' + err)
  }
}

// 检查lodop版本号
export function checkoutLodopVersion(callback = function () { }) {
  const LODOP = window.LODOP
  if (LODOP && LODOP.CVERSION < version) {
    // if (!needCLodop()) { document.body.innerHTML = (is64IE ? strHtm64_Update : strHtmUpdate) + document.body.innerHTML; }
    // alert(`您的lodop控件版本低于${version}，请前去下载更新`)
    callback(false)
    return false
  }
  callback(true)
  return true
}

// 下载lodop控件
export function downloadLodop() {
  const link = document.createElement('a')
  // link.href = 'http://www.lodop.net/download/CLodop_Setup_for_Win32NT_https_3.093Extend.zip'
  link.href = 'https://ocms.jtexpress.com.cn/common/lodop/CLodop_Setup_for_Win32NT_4.118.zip'
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
}

/**
 * @name 打印方法
 * @param {Object} options
 * @param {Array} options.images 数据列表（url|stream|img）
 * @param {Object} options.pageSize 也尺寸（width｜height）
 * @param {String} options.type 类型 url pdf|链接 stream|流数据 img|图片
 * @param {Bollean} options.isPrintView 打印预览状态（暂不使用）
 *
 */
export function printImages(options = {},callback) {
  const LODOP = window.LODOP
  console.log(LODOP)
  if (!LODOP) {
    alert('The print plug-in failed to load') // 打印插件加载失败
  }
  // images pdf图片地址
  let { images, pageSize = {}, type = 'url', isPrintView = false, printerValue } = options
  const printSize = 30 // 快速每次打印条数
  for (let i = 0; i < images.length; i++) {
    if (i % printSize === 0) {
      LODOP.PRINT_INIT('Print face sheet quickly' + i) // 快速打印面单
    }
    LODOP.NewPage()
    // if (images[i] && images[i].indexOf('.pdf') !== -1 && type === 'url') {
    // 不存在则继续下一个循环
    if (!images[i]) continue
    if (type === 'url') {
      // 拿到pdf格式数据，转成base64
      axios({
        url: images[i],
        method: 'GET',
        responseType: 'blob'
      }).then((response) => {
        // 处理流
        handleStream(printerValue, response.data, LODOP, isPrintView,callback)
      })
    } else if (type === 'stream') {
      // 处理流
      handleStream(printerValue, images[i], LODOP, isPrintView,callback)
    } else if (type === 'img') {
      // 处理图片
      LODOP.ADD_PRINT_IMAGE(0, 0, (pageSize.width || 100) + 'mm', (pageSize.height || 180) + 'mm', images[i])
      LODOP.SET_PRINT_STYLEA(0, 'Stretch', 2)
      if (i % printSize === (printSize - 1) || i === (images.length - 1)) {
        // LODOP.SET_PRINT_PAGESIZE(0, pageSize.width || 100, pageSize.height || 180, '')
        if (LODOP.blIslocal && isPrintView) {
          LODOP.PREVIEW() // 打印预览
        } else {
            LODOP.PRINT() 
            callback()
        }
      
      }
    }
  }
}

// 处理流
function handleStream(printerValue, data, LODOP, isPrintView = false,callback) {
  LODOP.SET_PRINTER_INDEXA(printerValue)
  const reader = new FileReader()
  reader.readAsDataURL(new Blob([data]))
  reader.onload = async function () {
    const img = await reader.result.replace('data:application/octet-stream;base64,', '')
    console.log(img)
    LODOP.ADD_PRINT_PDF(0, 0, '100%', '100%', img)
    // LODOP.SET_PRINT_PAGESIZE(0, pageSize.width || 100, pageSize.height || 180, '')
    if (LODOP.blIslocal && isPrintView) {
      LODOP.PREVIEW() // 打印预览
    } else {
        LODOP.PRINT()
        callback()
    }
  }
}

// ==判断是否需要CLodop(那些不支持插件的浏览器):==
function needCLodop() {
  try {
    const ua = navigator.userAgent;
    if (ua.match(/Windows\sPhone/i)) { return true; }
    if (ua.match(/iPhone|iPod|iPad/i)) { return true; }
    if (ua.match(/Android/i)) { return true; }
    if (ua.match(/Edge\D?\d+/i)) { return true; }

    const verTrident = ua.match(/Trident\D?\d+/i);
    const verIE = ua.match(/MSIE\D?\d+/i);
    let verOPR = ua.match(/OPR\D?\d+/i);
    let verFF = ua.match(/Firefox\D?\d+/i);
    const x64 = ua.match(/x64/i);
    if ((!verTrident) && (!verIE) && (x64)) { return true; } else if (verFF) {
      verFF = verFF[0].match(/\d+/);
      if ((verFF[0] >= 41) || (x64)) { return true; }
    } else if (verOPR) {
      verOPR = verOPR[0].match(/\d+/);
      if (verOPR[0] >= 32) { return true; }
    } else if ((!verTrident) && (!verIE)) {
      let verChrome = ua.match(/Chrome\D?\d+/i);
      if (verChrome) {
        verChrome = verChrome[0].match(/\d+/);
        if (verChrome[0] >= 41) { return true; }
      }
    }
    return false;
  } catch (err) {
    return true;
  }
}

export default getLodop

